import React, { Component } from "react";
import { reduxForm, Field } from "redux-form";
import { Form, Button } from "semantic-ui-react";

import capitalize from "lodash/capitalize";

const fields = [
  {
    label: "fecha limite",
    required: true,
    type: "date",
    name: "fecha_limite"
  },
  {
    label: "descripcion",
    name: "descripcion",
    required: true,
    type: "text"
  }
];

class FormNuevaTarea extends Component {
  handleReset = () => {
    this.props.reset();
    this.props.handleDescartar();
  };

  renderFields = fields.map(({ label, required, type, name }) => (
    <Field
      key={label}
      fluid
      id={label}
      name={name}
      type={type}
      component={Form.Input}
      label={capitalize(label)}
      required={required}
    />
  ));

  render() {
    const { handleSubmit, pristine, submitSucceeded } = this.props;
    return (
      <Form>
        <Form.Group widths="equal">{this.renderFields}</Form.Group>
        <Button
          disabled={pristine || submitSucceeded}
          content="Guardar"
          color="pink"
          onClick={handleSubmit(values => this.props.handleAddTarea(values))}
        />
        <Button content="Descartar" color="pink" onClick={this.handleReset} />
      </Form>
    );
  }
}

export default reduxForm({
  form: "FormNuevaTarea",
  enableReinitialize: true
})(FormNuevaTarea);



// WEBPACK FOOTER //
// ./src/pages/ventas/ventasNuevaTarea/FormNuevaTarea.jsx